import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyACPH5taaVTmIaiZWKim8ggX76My2ZIcwE",
  authDomain: "llfconnect.firebaseapp.com",
  projectId: "llfconnect",
  storageBucket: "llfconnect.firebasestorage.app",
  messagingSenderId: "247549722263",
  appId: "1:247549722263:web:1c46bcfa02b653440ab3d2",
  measurementId: "G-DLZQD55DSG"
};

const app = initializeApp(firebaseConfig);
const projectAuth = getAuth(app);
const projectFunctions = getFunctions(app, "us-central1");

export { app, projectAuth, projectFunctions }
